<template>
  <html>
    <head> </head>
    <body>
      <div>
        <navbar></navbar>

        <!--img
          id="header-s"
          src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/Loyalty-hub-header-l.png"
        /-->
      </div>
      <div class="profile header-banner">
        <img
          class="icon-redeem"
          src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-point.png"
        />
        <p style="color: #ffffff">คะเเนนสะสมของคุณ</p>
        <p style="font-size: 30px; margin-top: -27px; color: #ffffff">
          {{ info.point  | numFormat('0,000,000') }}
        </p>
      </div>
      <div class="container" style="margin-top: 220px; background: transparent;margin-bottom: 60px;">
        <div class="row">
          <div class="col">
            <div class="">
              <nav class="navbar navbar-light bg-light">
                <form class="container-fluid justify-content-start">
 
                  <div :class="(pointType == 'order')? '_btPro':'_btDo'" @click="show('order')">
                    <button
                     
                      :class="(pointType == 'order')? 'btn btn-outline-secondary me-2 light-color':'btn btn-outline-secondary me-2 '"
                      type="button"
                      
                    >
      สะสมคะแนน
                    </button>
                    <div class="line-c">
                    <hr :class="(pointType == 'order')" />
                  </div>
                  </div>
                  <div :class="(pointType == 'redeem')? '_btPro':'_btDo'" @click="show('redeem')">
                    <button :class="(pointType == 'redeem')? 'btn btn-outline-secondary me-2 light-color':'btn btn-outline-secondary me-2'" type="button"  >
                      แลกคะแนน
                    </button>
                  <div class="line-d">
                    <hr :class="(pointType == 'redeem')" />
                  </div>
                  </div>
                  
                  

                </form>
              </nav>
            </div>
          </div>
          <div class="row">
            <div class="col" v-if="pointType == 'order'">
              <!-- content -->
              <pre
                class="orderList"
                v-for="item in orderList"
                v-bind:key="item._id"
              ><a >คำสั่งเลขที่ {{item.hubspot_id}} <span style="
    font-family: 'Prompt';
    font-size: 17px;
    font-weight: 500;
    
">{{item.status | translateStatus}}</span></a><a >วันที่ {{item.createdAt | dateFormat}}</a><a >ยอดรวม {{item.amount | numFormat('0,000,000.00')}} บาท</a><a >ได้รับคะแนน {{ item.point | numFormat('0,000,000') }} คะแนน</a></pre>
            </div>
            <div class="col" v-if="pointType == 'redeem'">
              <!-- content -->
              <pre
                class="orderList"
                v-for="item in redeemApprovedList"
                v-bind:key="item._id"
              ><a >คำสั่งเลขที่ {{item.hubspot_id}} <span style="
    font-family: 'Prompt';
    font-size: 17px;
    font-weight: 500;
    
">{{item.status | translateStatus}}</span></a><a >วันที่ {{item.createdAt | dateFormat}}  </a><a >{{item.reward_name}} </a><a>มูลค่า {{item.reward_value | numFormat('0,000,000.00')}} บาท</a><a>คะแนนที่ใช้ {{ item.point | numFormat('0,000,000') }} คะแนน</a></pre>
            </div>
          </div>
        </div>
      </div>
    </body>
  </html>
</template>
<script>
//import axios from "axios";
import Navbar from "./navbar";
import { DateTimeFunc } from "../libs/constant.js";
export default {
  name: "LH04_Redeempoint",
  components: {
    navbar: Navbar,
  },
  filters: {
    translateStatus: function (val) {
      if (val == "Completed" || val == "Approved") {
        return "สำเร็จ";
      } else if (val == "Cancelled" || val == "Cancelled") {
        return "ยกเลิก";
      } else {
        return "กำลังดำเนินการ";
      }
    },
    dateFormat: function (val) {
      let ymd = val.substring(0, 10).split("-");
      //return "";
      let month = DateTimeFunc.TH_MONTH(ymd[1]);
      return ymd[2] + " " + month + " " + (parseInt(ymd[0]) + 543);//+' '+val.substring(11, 19);
    },
  },
  data() {
    return {
      pointType: "order",
      payload: {},
      info: this.$store.state.profile,
    };
  },
  computed: {
    /*
    completedOrderList() {
      return this.$store.state.completedOrder.filter(
        (item) => item.status == "Completed"
      );
    },
    redeemApprovedList() {
      return this.$store.state.redeem.history.filter((item) => item.status == "Approved");
    },
    */
    point() {
      return this.info.point || 0;
    },
    orderList() {
      return this.$store.state.orderList; //.filter(
      //(item) => item.status == "Completed"
      //return item;
      //);
    },
    PendingOrderList() {
      return this.$store.state.orderList; //.filter(
      //(item) => item.status == "Pending"
      //);
    },
    redeemApprovedList() {
      console.log(this.$store.state.redeem.history);
      return this.$store.state.redeem.history; //.filter(
      //(item) => item.status == "Approved"
      //);
    },
    redeemPendingList() {
      return this.$store.state.redeem.history; //.filter(
      //(item) => item.status == "Pending"
      //);
    },
  },
  mounted() {
    this.completedList();
    //this.$store.dispatch("orderList");
    //console.log(this.$store.state.completedOrder);
  },
  methods: {
    // goto(page) {
    //   console.log(page);
    //   this.$router.push({
    //     name: page,
    //     query: {
    //       apiKey: localStorage.getItem("apiKey"),
    //       custId: localStorage.getItem("custId"),
    //     },
    //   });
    // },
    show(type) {
      console.log(type);
      this.pointType = type;
    },
    completedList() {
      this.payload = {
        custId: localStorage.getItem("custId"),
        apiKey: localStorage.getItem("apiKey"),
      };
      this.$store.dispatch("orderList", {
        payload: this.payload,
        memberId: this.$store.state.profile._id,
      });
    },
  },
};
</script>
<style scoped>
@import "./Css/style.css";

.profile {
  width: 100%;
  top: 20px;
  position: absolute;
  overflow: visible;
}
.bg-white {
  background: #7bc79a;
  border-radius: 10px;
  height: 538px;
  position: relative;
  overflow: visible;
  top: 154px;
  display: block;
  width: 90%;
}

.name-profile {
  color: #231f20;
  padding: 15px 0px 0px 15px;
}

h1 {
  font-size: 20px;
  margin-top: 30px;
}
p {
  font-size: 16px;
  color: #7f8285;
  text-align: center;
  margin-left: 0px;
}
.mt-30 {
  margin-top: 126px;
  text-align: center;
}
.mt-3 {
  margin-top: 126px;
  text-align: center;
  background: rgb(129, 129, 129);
}
.bt {
  top: 20px;
  border-radius: 10px;
  position: relative;
  overflow: visible;
}
.orderList {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0.25em;
  padding-bottom: 0.25em;
  margin-top: 0.1em;
  background: white;
  padding: 15px;
  font-family: "Prompt", sans-serif;
}
.orderList a{
  display:block;
}
.row {
  margin-left: 0px !important;
}
.container-fluid{
  display: flex;
}
form.container-fluid.justify-content-start {
  justify-content: center; 
}
.container {
  background: transparent;
}
.row > * {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.btn-outline-danger {
  color: #fff;
  /*background-color: #b50610;
  border-color: #b50610;*/
}
.btn-outline-danger:hover {
  color: #fff;
  /*background-color: #b50610;*/
  /*border-color: #b50610;*/
}
.btn-outline-secondary:hover {
  color: #fff;
  /*background-color: #b50610;
  border-color: #b50610;*/
}

.btn-check:active + .btn-outline-danger:focus,
.btn-check:checked + .btn-outline-danger:focus,
.btn-outline-danger.active:focus,
.btn-outline-danger.dropdown-toggle.show:focus,
.btn-outline-danger:active:focus {
  box-shadow: transparent !important;
}
.btn-check:active + .btn-outline-secondary:focus,
.btn-check:checked + .btn-outline-secondary:focus,
.btn-outline-secondary.active:focus,
.btn-outline-secondary.dropdown-toggle.show:focus,
.btn-outline-secondary:active:focus {
  box-shadow: transparent !important;
}
.btn-check:focus + .btn-outline-secondary,
.btn-outline-secondary:focus {
  box-shadow: 0 0 0 0 transparent;
}
.btn-check:focus + .btn-outline-danger,
.btn-outline-danger:focus {
  box-shadow: 0 0 0 0 transparent;
}
</style>
